import {i18n} from '../plugins/i18n'

const state = {
    user: {},
    token: null,
    company: {},
    stage: {},
    role:{},
    period:{},
    sector:{},
    roles: [],
    leadership:{},
    objective:{},
    stereotypes:{},
    menu:[],
    periods:[],
    sectores:[],
    assessments:[],
    periodsSlave: [],
    periodMaster: [],
    periodSlave: {},
    stageSlave: {},
    perspectives: []
}

const mutations = {
    populateUser(base, userDB){
        //console.log(userDB)

        base.user = {
            id: userDB.id,
            name: userDB.name,
            email: userDB.email
        }

        const userCompany = userDB.userCompanies.find(uc => uc.id === parseInt(localStorage.getItem('adv-user-company'))) || userDB.userCompanies[0];
        localStorage.setItem('adv-user-company', userCompany.id);
        base.company = userCompany.company;
        
        //stage
        const stage = userCompany.company.stages.find(st => st.id === parseInt(localStorage.getItem('adv-stage'))) || userCompany.company.stages[0];
        localStorage.setItem('adv-stage', stage.id);
        
        base.stage = stage;
        base.perspectives = stage.perspectives;
        base.stereotypes = stage.stereotypes;

        // period
        base.periods = stage.periods.sort((a,b) => (a.sorter || 0) - (b.sorter||0));
        const period = stage.periods.find(a => a.id === parseInt(localStorage.getItem("adv-period"))) || stage.periods.find(a => a.active) || stage.periods[0];
        localStorage.setItem('adv-period', period.id);
        base.period = period;


        // roles
        base.roles = [];
        userCompany.roles.forEach(r => {
            base.roles.push(r.role);
        })

        const role = base.roles.find(r => r.id === parseInt(localStorage.getItem("adv-role"))) || base.roles[0];
        localStorage.setItem("adv-role", role.id);
        base.role = role;

        // sector
        base.sector = userCompany.sectors.find(a => a.stageId === stage.id).sector || {}


        

        




















        /*const {companies} = userDB;
        
        let {stages, ...companyData} = companies.find(x => x.state === '1')
        if(localStorage.getItem("adv-company")){
            let tempInfo = companies.find(x => x.id + '' === localStorage.getItem("adv-company"))
            if(tempInfo){
                stages = tempInfo.stages;
                companyData = tempInfo; 
            }
        }
        let currentStage = stages.find(x => x.state === '1');
        if( localStorage.getItem("adv-stage")){
            stages.forEach(s => {
                if(s.id + '' === localStorage.getItem("adv-stage")){
                    currentStage = s;
                }
            })
        }
        //console.log(currentStage);
        //const {sectors, ...stageData} = localStorage.getItem("adv-stage") ? stages.find(x => x.id + '' === localStorage.getItem("adv-stage")) || stages.find(x => x.state === '1') : stages.find(x => x.state === '1')
        const {sectors, ...stageData} = currentStage
        //const {roles} = companies.find(x => x.state === '1')
        //const {periods} = currentStage;
        const {groups} = currentStage;
        const {sectores} = currentStage;


        //localStorage.setItem("hope", userBD.token);
        base.user = userData;
        base.company = companyData;
        base.stage = stageData;
        base.groups = groups;
        base.role = localStorage.getItem("adv-role") ? roles.find(x => x.id + '' === localStorage.getItem("adv-role")) || roles.find(x => x.state === '1') : roles.find(x => x.state === '1')
        //base.period = localStorage.getItem("adv-period") ? periods.find(x => x.id + '' === localStorage.getItem("adv-period")) || periods.find(x => x.state === '1') : periods.find(x => x.state === '1')
        base.period = periods.find(x => x.state === '1')
        if( localStorage.getItem("adv-period")){
            periods.forEach(p => {
                if(p.id + '' === localStorage.getItem("adv-period") + ''){
                    base.period = p; 
                }
            })
        }*/
        
        //base.sector = sectors.find(x => x.state === '1')
        //base.leadership = base.sector.leadership;
        //base.stereotypes = stageData.stereotypes;
        //base.periods = periods;

        //base.sectores = sectores;

        base.menu = [
            {id: 7, name: i18n.t('menu.operational'), icon:'mdi-sitemap', path :'/app/indicadores-stereotype'},
            {id: 13, name: i18n.t('menu.tactic'), icon:'mdi-human-capacity-increase', path :'/app/kpi-analysis'},
            {id: 14, name: i18n.t('menu.strategic'), icon:'mdi-human-capacity-increase', path :'/app/kpi-manager'},
            //{id: 8, name: 'Gerencia', icon:'mdi-monitor-dashboard', path :'/app/ceo'},
            {id: 9, name: i18n.t('menu.plan'), icon:'mdi-file-table', path :'/app/feedback'},
            //{id: 15, name:  i18n.t('menu.process'), icon:'mdi-cog-clockwise', path :'/app/process'},
            {id: 10, name:  i18n.t('menu.map'), icon:'mdi-map', path :'/app/map'},
            {id: 11, name:  i18n.t('menu.risk'), icon:'mdi-flag', path :'/app/riesgo'},
            {id: 12, name:  i18n.t('menu.ose'), icon:'mdi-poll', path :'/app/ose'},
            {id: 16, name:  i18n.t('menu.epr'), icon:'mdi-file', path :'/app/epr'},
            {id: 17, name:  i18n.t('menu.checklist'), icon:'mdi-check-all', path :'/app/checklist'},
            {id: 1, name: i18n.t('menu.advance'), icon:'mdi-counter', path :'/app/avances'},
           // {id: 2, name: 'Indicadores 1', icon:'mdi-monitor-dashboard', path :'/app/kpi'},
            {id: 3, name:  i18n.t('menu.review'), icon:'mdi-check', path: '/app/evaluar'},
            {id: 4, name:  i18n.t('menu.agreement'), icon:'mdi-clipboard-check-multiple', path: '/app/acuerdos'},
            {id: 5, name:  i18n.t('menu.report'), icon:'mdi-file-document-multiple', path :'/app/reportes'},
            {id: 6, name:  i18n.t('menu.config'), icon:'mdi-tools', path :'/app/configuraciones'},
        ]

        
        /*localStorage.setItem("adv-period", base.period.id)
        localStorage.setItem("adv-stage", base.stage.id)
        localStorage.setItem("adv-role", base.role.id)
        localStorage.setItem("adv-company", base.company.id)
        */
    },

    logOut(base){
        localStorage.removeItem("hope");
        localStorage.removeItem("adv-period")
        localStorage.removeItem("adv-stage")
        localStorage.removeItem("adv-role")
        base.user =  {}
        base.token =  null
        base.company =  {}
        base.stage =  {}
        base.role = {}
        base.period = {}
        base.sector = {}
        base.leadership = {}
        base.objective = {}
    },
    setPeriod(base, period){
        localStorage.setItem("adv-period", period.id)
        base.period = period;
    },
    setPeriods(base, periods){
        base.periods = periods;
    },
    setStage(base, stage){
        base.stereotypes = stage.stereotypes;
        base.perspectives = stage.perspectives;
        localStorage.setItem("adv-stage", stage.id)
        base.stage = stage;
    },
    setSector(base, sector){
        base.sector = sector;
    },
    setRole(base, role){
        localStorage.setItem("adv-role", role.id)
        base.role = role;
    },
    setAssessments(base, data){
        base.assessments = data;
    },
    setStageSlave(base, stage){
        base.stageSlave = stage;
    },
    setPeriodsSlave(base, periods){
        base.periodsSlave = periods;
        base.periodSlave = periods.at(0) || {}
    },
    changePeriodSlave(period){
        base.periodSlave = period
    }

}

const getters = {
    isLogin(base){
        if(base.user.id){
            return true;
        }return false;
    },
    periodId(base){
        if(base.period){
            return base.period.id;
        }return '';
    },
    periodEnable(base){
        if(base.period){
            return base.period.active;
        }return false;
    },
    getMenu(base){
        const comun = [7,9,8,4,5,1,11,12, 13, 15];
        const controller = [1,3];
        const feedback = [1,3]
        const quality = [7,1,4,5];
        if(base.role.id === 3){
            return base.menu.filter(x => controller.find(e => e === x.id))
        }else if(base.role.id === 4){
            return base.menu.filter(x => feedback.find(e => e === x.id))
        }else if(base.role.id === 2){
            return base.menu.filter(x => comun.find(e => e === x.id))
        }else if(base.role.id === 6){
            return base.menu.filter(x => quality.find(e => e === x.id))
        }
        return base.menu;
    },
    getPeriods(base){
        return base.periods.sort((a,b)=>a.order - b.order);
    },
    getRoles(base){
        return base.roles.sort((a,b)=>a.id - b.id);
    },
    getAssessments(base){
        return base.assessments;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
}